import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import Settings from './components/Settings';
import AdminAffiliate from './components/AdminAffiliate';
import Affiliate from './components/Affiliate';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

const App = () => {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    isAdmin: false,
    isLoading: true,
  });

  useEffect(() => {
    const verifyAuth = async () => {
      const token = localStorage.getItem('token');
      const storedIsAdmin = localStorage.getItem('isAdmin') === 'true';

      if (!token) {
        setAuthState({
          isAuthenticated: false,
          isAdmin: false,
          isLoading: false,
        });
        return;
      }

      try {
        const response = await fetch('https://starcopy.online/api/account/info', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          setAuthState({
            isAuthenticated: true,
            isAdmin: storedIsAdmin,
            isLoading: false,
          });
        } else {
          // Clear invalid auth state
          localStorage.removeItem('token');
          localStorage.removeItem('isAdmin');
          setAuthState({
            isAuthenticated: false,
            isAdmin: false,
            isLoading: false,
          });
        }
      } catch (error) {
        console.error('Auth verification failed:', error);
        setAuthState({
          isAuthenticated: false,
          isAdmin: false,
          isLoading: false,
        });
      }
    };

    verifyAuth();
  }, []);

  if (authState.isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* PUBLIC ROUTES - These must come FIRST before any authentication checks */}
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        
        <Route
          path="/login"
          element={
            authState.isAuthenticated ? (
              <Navigate to={authState.isAdmin ? "/admin/dashboard" : "/"} replace />
            ) : (
              <LoginPage />
            )
          }
        />

        {/* Admin routes */}
        <Route
          path="/admin/dashboard"
          element={
            !authState.isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : !authState.isAdmin ? (
              <Navigate to="/" replace />
            ) : (
              <Layout isAdmin={true}>
                <AdminDashboard />
              </Layout>
            )
          }
        />

        <Route
          path="/admin/affiliate"
          element={
            !authState.isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : !authState.isAdmin ? (
              <Navigate to="/" replace />
            ) : (
              <Layout isAdmin={true}>
                <AdminAffiliate />
              </Layout>
            )
          }
        />

        {/* Redirect /admin to /admin/dashboard */}
        <Route
          path="/admin"
          element={<Navigate to="/admin/dashboard" replace />}
        />

        {/* User routes */}
        <Route
          path="/"
          element={
            !authState.isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : (
              <Layout isAdmin={false}>
                <Dashboard />
              </Layout>
            )
          }
        />

        <Route
          path="/affiliate"
          element={
            !authState.isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : (
              <Layout isAdmin={false}>
                <Affiliate />
              </Layout>
            )
          }
        />

        <Route
          path="/settings"
          element={
            !authState.isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : (
              <Layout isAdmin={false}>
                <Settings />
              </Layout>
            )
          }
        />

        {/* Simple catch-all redirect - no special logic needed */}
        <Route
          path="*"
          element={<Navigate to="/login" replace />}
        />
      </Routes>
    </Router>
  );
};

export default App;
